import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { memo } from "react";
import SectionContainer from "../../../../../common/SectionContainer";
import { Data } from "../../../../../store/terminal/types";
import { getValueForField } from "../editConfigurationComponent/ConfigurationOptions";
import { FastField, Field, FormikProps, useFormikContext } from "formik";
import NumberFormat from "react-number-format";
import { Alert } from "@mui/lab";
import pageStyles from "./../../../../pageStyles";
import TextInput from "../../../../../common/formElements/TextInput";
import CustomizedSwitch from "../../../../../common/formElements/Switch";

interface EditFixedAmountEntryProps {
  bulk: boolean;
  isUpdateAllowed?: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

function EditFixedAmountEntryForm({
  bulk,
  isUpdateAllowed,
  shouldHideField,
}: EditFixedAmountEntryProps) {
  const classes = pageStyles();
  const formProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue } = formProps;
  const values = (formProps.values as unknown) as Data;
  const errors = (formProps.errors as unknown) as Data;

  const isUserConfigChecked =
    values.attributes.FixedAmountEntryUseUserSupplied === "Yes";
  return (
    <SectionContainer
      heading="Fixed Amount Entry for Payment UI"
      name="sections.fixedamountentryform"
      bulk={bulk}
    >
      <Grid container alignItems="flex-start" spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextInput
              required
              label="Prompt Text"
              fieldname="attributes.FixedAmountEntryTitle"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            style={{ marginLeft: "5px" }}
            label={"Enable user configuration on terminal for input values."}
            control={
              <CustomizedSwitch
                name="Allow User Configuration for fixed amount entry"
                checked={isUserConfigChecked}
                onChange={(event, value) => {
                  setFieldValue(
                    "attributes.FixedAmountEntryUseUserSupplied",
                    getValueForField(
                      "attributes.FixedAmountEntryUseUserSupplied",
                      value
                    )
                  );
                }}
                disabled={!isUpdateAllowed}
              />
            }
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Field
              name="attributes.FixedAmountEntryValue1"
              variant="outlined"
              as={NumberFormat}
              customInput={TextField}
              isNumericString={false}
              error={errors.attributes?.FixedAmountEntryValue1}
              helperText={errors.attributes?.FixedAmountEntryValue1}
              // type={'text'}
              // renderText={formattedValue => <Text>{formattedValue}</Text>} // <--- Don't forget this!
              label="Fixed Amount Entry 1 (Cents Whole Number)"
              fullWidth
              thousandSeparator={false}
              prefix={""}
              decimalScale={0}
              fixedDecimalScale={true}
              inputProps={{
                readOnly: isUserConfigChecked,
              }}
              onChange={(e: { target: { value: any } }) => {
                setFieldValue(
                  "attributes.FixedAmountEntryValue1",
                  e.target.value
                );
              }}
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Field
              name="attributes.FixedAmountEntryValue2"
              as={NumberFormat}
              variant="outlined"
              customInput={TextField}
              isNumericString={false}
              error={errors?.attributes?.FixedAmountEntryValue2}
              helperText={errors?.attributes?.FixedAmountEntryValue2}
              label="Fixed Amount Entry 2 (Cents Whole Number)"
              fullWidth
              thousandSeparator={false}
              prefix={""}
              decimalScale={0}
              fixedDecimalScale={true}
              inputProps={{
                readOnly: isUserConfigChecked,
              }}
              onChange={(e: { target: { value: any } }) => {
                setFieldValue(
                  "attributes.FixedAmountEntryValue2",
                  e.target.value
                );
              }}
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Field
              name="attributes.FixedAmountEntryValue3"
              as={NumberFormat}
              customInput={TextField}
              isNumericString={false}
              error={errors?.attributes?.FixedAmountEntryValue3}
              helperText={errors?.attributes?.FixedAmountEntryValue3}
              variant="outlined"
              // type={'text'}
              // renderText={formattedValue => <Text>{formattedValue}</Text>} // <--- Don't forget this!
              label="Fixed Amount Entry 3 (Cents Whole Number)"
              fullWidth
              thousandSeparator={false}
              prefix={""}
              decimalScale={0}
              fixedDecimalScale={true}
              inputProps={{
                readOnly: isUserConfigChecked,
              }}
              onChange={(e: { target: { value: any } }) => {
                setFieldValue(
                  "attributes.FixedAmountEntryValue3",
                  e.target.value
                );
              }}
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <Field
              name="attributes.FixedAmountEntryValue4"
              as={NumberFormat}
              customInput={TextField}
              variant="outlined"
              isNumericString={false}
              error={errors?.attributes?.FixedAmountEntryValue4}
              helperText={errors?.attributes?.FixedAmountEntryValue4}
              label="Fixed Amount Entry 4 (Cents Whole Number)"
              fullWidth
              thousandSeparator={false}
              prefix={""}
              decimalScale={0}
              fixedDecimalScale={true}
              inputProps={{
                readOnly: isUserConfigChecked,
              }}
              onChange={(e: { target: { value: any } }) => {
                setFieldValue(
                  "attributes.FixedAmountEntryValue4",
                  e.target.value
                );
              }}
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        {isUserConfigChecked && (
          <Alert severity="info">
            Note you cannot observe or change values from TMS when user config
            is enabled. The values are set on the terminal itself.
          </Alert>
        )}
      </Grid>
    </SectionContainer>
  );
}
export default memo(EditFixedAmountEntryForm);
